// Vendor Libs
import React from 'react';

// Components
import EditShell from '../app/edit-shell';
import FlexDashboard from '../core/flex-dashboard';
import MediaItemsMapped from '../search-data/media-items-mapped';
import MoviesAndPrograms from '../search-data/movies-and-programs';
import MoviesAndProgramsDetail from '../search-data/movies-and-programs-detail';
import MoviesAndProgramsEpisodes from '../search-data/movies-and-programs-episodes';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Movies And Programs Detail',
                                component: MoviesAndProgramsDetail,
                                config: {
                                    componentProps: {},
                                },
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Movies And Programs',
                                component: MoviesAndPrograms,
                                config: {
                                    componentProps: {},
                                },
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        name: 'Mapped Media Items',
                        type: 'tab',
                        component: MediaItemsMapped,
                        config: {
                            componentProps: {
                                type: 'enhancedMediaItem',
                            },
                        },
                    },
                    {
                        name: 'Associated Episodes',
                        type: 'tab',
                        component: MoviesAndProgramsEpisodes,
                        config: {
                            componentProps: {
                                type: 'enhancedMediaItem',
                            },
                        },
                    },
                    {
                        type: 'tab',
                        name: 'Edit Shell',
                        component: EditShell,
                    },
                ],
            },
        ],
    },
};

function DashboardMoviesAndPrograms() {
    return (
        <FlexDashboard
            dashboardConfig={getDashboardConfig(dashboardConfig)}
            dashboardName="moviesAndPrograms"
            version="2"
        />
    );
}

export default DashboardMoviesAndPrograms;
